<template>
  <div style="padding-top: 8px; height: 100%">
    <span v-if="!panes.length" style="color: #00000073">当前无 SQL 执行结果</span>
    <div v-else style="height: 100%" class="flex-col">
      <a-tabs v-model="activeKey" hide-add type="editable-card" @edit="onEdit">
        <a-tab-pane v-for="pane in panes" :key="pane.key" :closable="pane.closable">
          <span slot="tab">
            <a-badge v-if="newInfoNum && pane.key === INFO_PANE" :count="newInfoNum">
              <span class="select-none">{{ pane.title }}</span>
            </a-badge>
            <span v-else class="select-none">{{ pane.title }}</span>
          </span>
        </a-tab-pane>
        <a-button
          slot="tabBarExtraContent"
          @click="handleClear"
          @mouseover="cleanIconHover(true)"
          @mouseleave="cleanIconHover(false)"
        >
          <img :src="require('@/assets/icon/' + cleanIcon + '.svg')" class="mgr-8" />
          清空结果
        </a-button>
      </a-tabs>
      <div style="overflow: hidden; flex: 1">
        <tab-pane-console
          ref="tab_pane_console"
          v-if="activeKey === INFO_PANE"
          :infoList="currentPane.content"
          :panes="panes"
          @handleToResult="handleSelect"
          @clickSql="(val) => this.$emit('tabChange', val)"
        ></tab-pane-console>
        <tab-pane-result
          v-else
          :result="currentPane"
          @clickSql="(val) => this.$emit('tabChange', val)"
        ></tab-pane-result>
      </div>
    </div>
  </div>
</template>

<script>
import { runSqlApi } from '@/api/sql'
import TabPaneConsole from './TabPaneConsole.vue'
import TabPaneResult from './TabPaneResult.vue'
import { RUNNING } from '@/store/mutation-types'

const INFO_PANE = 'info'

export default {
  name: 'SqlResult',
  components: { TabPaneConsole, TabPaneResult },
  data() {
    return {
      cleanIcon: 'clearDelete',
      panes: [], // 正常情况下第一项是总体的信息tab，但是可以删除，后面几项都是结果
      activeKey: localStorage.getItem('activeKey') || '',
      resultId: localStorage.getItem('resultId') || 1,
      INFO_PANE,
      newInfoNum: 0,
      execTime: 0,
    }
  },
  mounted() {
    try {
      // 如果用户修改了这部分内容，会直接挂掉，所以try catch一下
      this.panes = JSON.parse(localStorage.getItem('panes') || '[]')
    } catch (error) {
      this.panes = []
    }
  },
  watch: {
    activeKey(key) {
      localStorage.setItem('activeKey', key)
      if (!key || key === INFO_PANE) this.newInfoNum = 0
      else this.$emit('tabChange', this.currentPane.sql)
    },
    panes: {
      deep: true,
      handler: function (val) {
        localStorage.setItem('panes', JSON.stringify(val))
      },
    },
    resultId(val) {
      localStorage.setItem('resultId', val)
    },
  },
  computed: {
    currentPane() {
      return this.panes.find((pane) => pane.key === this.activeKey) || {}
    },
  },
  methods: {
    cleanIconHover(flag) {
      setTimeout(() => {
        if (flag) this.cleanIcon = 'clearDelete_hover'
        else this.cleanIcon = 'clearDelete'
      }, 100)
    },
    handleRunSql(sql) {
      return new Promise((resolve) => {
        this.$store.commit(RUNNING, true)
        const param = { sql: sql }
        let execStartTime = new Date().getTime()
        runSqlApi(param)
          .then((res) => {
            let execEndTime = new Date().getTime()
            this.execTime = execEndTime - execStartTime
            this.dealResults(res.content)
          })
          .catch((res) => {
            this.$message.error('执行错误：' + res.response.data.msg)
          })
          .finally(() => {
            this.$store.commit(RUNNING, false)
            resolve()
          })
      })
    },
    dealResults(results) {
      var tmpInfoPane = { key: INFO_PANE, title: 'Console', content: [] }
      if (this.panes.findIndex((item) => item.key === INFO_PANE) === -1) {
        this.panes.unshift(tmpInfoPane)
      }
      var infoPane = this.panes[0]
      let latestPaneIndex = this.panes.length - 1
      results.forEach((result) => {
        if (result.type === 'error') {
          result.execTime = this.execTime
          infoPane.content.push(result)
        } else if (result.type === 'result') {
          const temp = {
            message: result.sqlType == 'PL/SQL' ? result.plsqlResult.trim() : 'Succeed.',
            type: 'success',
            sql: result.sql,
            startTime: result.startTime,
            endTime: result.endTime,
            escapeTime: result.escapeTime,
            execTime: this.execTime,
          }
          infoPane.content.push(temp)
          if (result?.columns?.length) {
            // columns 有东西,就生成一个结果tab
            const resultPane = {
              key: 'Result [' + this.resultId + ']',
              title: 'Result [' + this.resultId + ']',
              execTime: this.execTime,
              ...result,
            }
            temp.resultTabKey = 'Result [' + this.resultId + ']'
            this.resultId++
            this.panes.push(resultPane)
          }
        }
      })
      if (!this.activeKey) {
        this.activeKey = INFO_PANE
      } else if (this.activeKey !== INFO_PANE) {
        this.newInfoNum += results.length
      }
      if (latestPaneIndex != this.panes.length - 1) {
        this.activeKey = this.panes[latestPaneIndex + 1].key
      } else {
        this.activeKey = INFO_PANE
      }
      // 如果是 console 的页面，自动滑到底部
      this.$nextTick(() => {
        const tabPaneConsoleEl = this.$refs.tab_pane_console
        if (tabPaneConsoleEl) {
          tabPaneConsoleEl.$el.scrollTop = tabPaneConsoleEl.$el.scrollHeight
        }
      })
    },
    handleClear() {
      this.panes = []
      this.activeKey = ''
      this.resultId = 1
    },
    onEdit(targetKey) {
      if (targetKey === INFO_PANE) {
        this.newInfoNum = 0
      }
      const targetIndex = this.panes.findIndex((item) => item.key === targetKey)
      if (targetIndex > -1) {
        this.panes.splice(targetIndex, 1)
      }
      if (this.activeKey === targetKey) {
        // 删除的不是第一项，就选取前一项
        if (targetIndex > 0) {
          this.activeKey = this.panes[targetIndex - 1].key
        } else if (this.panes.length) {
          // 删除的是第一项，但是后面有内容，就选取删后第一项的内容
          this.activeKey = this.panes[0].key
        } else {
          // 删除的是第一项且仅有此项时
          this.activeKey = ''
        }
      }
    },
    handleSelect(key) {
      this.activeKey = key
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
/deep/.resize-table-th {
  position: relative;
}
</style>
